
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Loading } from "../../../../componentes/loading/loading";

export default function SolicitacoesPorFaixaPreco({ data, loading, filtrar, alterarFaixa }) {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const [labels, setLabels] = useState([]);

  useEffect(() => {
    if (data?.faixa) {
      const faixaLabels = Object.keys(data.faixa);
      const valores = Object.values(data.faixa);

      setLabels(faixaLabels);

      setChartOptions({
        chart: {
          type: "pie",
          toolbar: { show: true },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const index = config.dataPointIndex;
              const label = faixaLabels[index];
              alterarFaixa(label);
            }
          }
        },
        stroke: {
          show: false,
          width: 0
        },
        labels: faixaLabels,
        legend: {
          position: "bottom",
          fontSize: "14px"
        },
        colors: [
          "#f4f801ff", // Faixa 1
          "#14B8A6",   // Faixa 2
          "#f01d16ff"  // Faixa 3
        ],
        tooltip: {
          y: {
            formatter: (value) => `${value} solicitações`
          }
        }
      });

      setChartSeries(valores);
    } else {
      setChartSeries([]);
    }
  }, [data, filtrar]);

  return (
    <div className="bg-card border border-border rounded-lg shadow-card p-4 lg:min-h-[425px]">
      <h3 className="text-lg font-display font-semibold text-foreground mb-1">
        Solicitações por Faixa de Preço
      </h3>
      <label className="text-muted-foreground text-sm">
        Comparativo da quantidade de solicitações por faixa de preço.
      </label>
    
        {!loading ? (
          data.solicitacoes.length > 0 && chartSeries.length > 0 ? (
            <Chart
              options={chartOptions}
              series={chartSeries}
              type="pie"
              height={260}
            />
          ) : (
            "Não existem dados disponíveis para o intervalo selecionado."
          )
        ) : (
          <Loading />
        )}
  
    </div>
  );
}
